// Just a page that shows a message saying the booking request was sent

// MUI IMPORTS
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

//THE ACTUAL PAGE
export const BookingRequestSent = () => {
  const navigate = useNavigate();

  return (
    <div className="page">
      <Typography variant="h4" gutterBottom>
        We've received your booking and we will get back to you within 72 hours.
        Completion of this form does not guarantee a reservation; each
        application is reviewed by our staff and if we have a suitable site
        available, we will accept the deposit and send a confirmation email
        within 72 hours. In the meantime, you may see a pending or
        authorized transaction on your card.
      </Typography>
      <Button variant="outlined" onClick={() => navigate("/")}>
        Back to home page
      </Button>
    </div>
  );
};
